import {remCalc} from '_themeUtils'

const control_default = {
    position: 'relative',
    w: remCalc(20),
    h: remCalc(20),
    border: 1,
    borderStyle: 'solid',
    borderColor: 'color.border.input.primary',
    borderRadius: 'borderRadius.input.base',
    mt: remCalc(-2),
    transition: 'all .2s ease-in-out',

    _disabled: {
        bg: 'color.background.input.primary',
        borderColor: 'color.border.input.disabled',

        _hover: {
            bg: 'color.background.input.primary',
            borderColor: 'color.border.input.disabled',
        },
    },
    _invalid: {
        borderColor: 'color.border.input.error',
    },
}

const control_checked_default = {
    bg: 'color.background.transparent',
    borderColor: 'color.border.input.primary',
    _hover: {
        borderColor: 'color.border.input.primary',
        bg: 'color.background.transparent',
    },
    _disabled: {
        bg: 'color.background.grey[400]',
        borderColor: 'color.border.input.disabled',
        outlineWidth: remCalc(1.5),
        outlineOffset: remCalc(-2),
        outlineColor: 'color.border.white',

        _hover: {
            bg: 'color.background.grey[400]',
            borderColor: 'color.border.input.disabled',
        },
    },
}

const checkbox = {
    Checkbox: {
        baseStyle: {
            container: {
                w: 'fit-content',
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
                mb: 'spacing.6',
                _focusWithin: {
                    outlineOffset: remCalc(2),
                    outline: '2px solid #1e90ff',
                },
            },
            label: {
                fontSize: 'inherit',
                color: 'color.text.input.base',
                fontWeight: '400',

                pl: 'spacing.1',
                _invalid: {
                    color: 'color.text.input.error',
                },
            },
            control: {
                ...control_default,

                _focus: {
                    outline: 'none',
                    boxShadow: 'none',
                },
                _before: {
                    content: '""',
                    width: remCalc(0),
                    height: remCalc(0),
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    bg: 'color.background.black',
                    lineHeight: 0,
                    transform: 'translate(-50%, -50%)',
                    opacity: 0,
                    transition: 'all .2s ease-in-out',
                },

                _checked: {
                    ...control_checked_default,

                    _before: {
                        width: remCalc(11),
                        height: remCalc(11),
                        opacity: 1,
                    },
                },

                _disabled: {
                    ...control_default._disabled,
                    _before: {
                        bg: 'color.background.white',
                    },
                },
            },
            icon: {
                display: 'none',
            },
        },
        sizes: {
            xs: {
                container: {
                    pl: 'spacing.1',
                    mb: 'spacing.4',
                },
                control: {
                    w: remCalc(12),
                    h: remCalc(12),

                    _checked: {
                        _before: {
                            width: remCalc(6),
                            height: remCalc(6),
                        },
                    },
                },
                label: {
                    fontWeight: '300',
                },
            },
            sm: {
                container: {
                    mb: 'spacing.2',
                },
                control: {
                    w: remCalc(16),
                    h: remCalc(16),

                    _checked: {
                        _before: {
                            width: remCalc(8),
                            height: remCalc(8),
                        },
                    },
                },
                label: {
                    fontWeight: '300',
                    fontSize: remCalc(14),
                    letterSpacing: remCalc(1),
                    p: '0',
                },
            },
        },
    },
}

export default checkbox
